import {
  SR_API_ACTION_PLAID_GET_LINK_TOKEN,
} from 'api/actionTypes';

export default async function getLinkToken(
  { state, apiClient },
  { userId, accessToken }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_PLAID_GET_LINK_TOKEN,
    state: state,
    payload: {
      userId,
      accessToken,
    },
    onSuccess(token) {
      state.set(['plaidLinkToken'], token);
    },
  });
}
